(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product_page_trust_pilot_widget"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const widget = document.getElementById('pdp-trustpilot-widget');
  if (!widget) return;

  setTimeout(() => {
    const iframe = widget.querySelector('iframe');
    if (!iframe) return;

    if (iframe.style.display === 'none') {
      widget.style.padding = '0';
      widget.style.height = '0';
      widget.style.overflow = 'hidden';
      widget.style.background = 'transparent';
    }
  }, 1000);
});

  } catch(e) { console.error(e); }
})();
})();
